import { PolicyActions, PolicyColEnum, PolicyManagementSortFieldEnum } from '@core/enum/policy';
import { KeyedValue } from '@core/models/interfaces/common';
import { CustomColumn } from '@core/models/interfaces/custom-column';

export const UpdateType: KeyedValue[] = [
  {
    value: PolicyActions.CANCEL,
    title: 'cancel'
  },
  {
    value: PolicyActions.UPGRADE,
    title: 'upgrade'
  },

  {
    value: PolicyActions.DOWNGRADE,
    title: 'downgrade'
  },
  {
    value: PolicyActions.ORIGINAL,
    title: 'create'
  },
  {
    value: PolicyActions.NONE,
    title: 'edit'
  }
];

export const SecretKey = 'youhavetobeadmintoaccessthis@456'; // Delete

export const PolicyColSorts: { [key: string]: PolicyManagementSortFieldEnum } = {
  [PolicyColEnum.NUMBER]: PolicyManagementSortFieldEnum.NUMBER,
  [PolicyColEnum.LEAD]: PolicyManagementSortFieldEnum.LEAD,
  [PolicyColEnum.CREATED_AT]: PolicyManagementSortFieldEnum.CREATED_AT,
  [PolicyColEnum.OWNER]: PolicyManagementSortFieldEnum.OWNER,
  [PolicyColEnum.AGENT]: PolicyManagementSortFieldEnum.AGENT,
  [PolicyColEnum.STATUS]: PolicyManagementSortFieldEnum.STATUS,
  [PolicyColEnum.TRACKING]: PolicyManagementSortFieldEnum.TRACKING,
  [PolicyColEnum.EFFECTIVE_DATE]: PolicyManagementSortFieldEnum.EFFECTIVE_DATE,
  [PolicyColEnum.MODE]: PolicyManagementSortFieldEnum.MODE,
  [PolicyColEnum.PAYMENT]: PolicyManagementSortFieldEnum.PAYMENT,
  [PolicyColEnum.TARGET]: PolicyManagementSortFieldEnum.TARGET,
  [PolicyColEnum.FACE_AMOUNT]: PolicyManagementSortFieldEnum.FACE_AMOUNT,
  [PolicyColEnum.COMPANY]: PolicyManagementSortFieldEnum.COMPANY,
  [PolicyColEnum.PRODUCT_TYPE]: PolicyManagementSortFieldEnum.PRODUCT_TYPE,
  [PolicyColEnum.PRODUCT_NAME]: PolicyManagementSortFieldEnum.PRODUCT_NAME,
  [PolicyColEnum.CONTRIBUTION_YEARS]: PolicyManagementSortFieldEnum.CONTRIBUTION_YEARS,
  [PolicyColEnum.COMMISSION_OWNER]: PolicyManagementSortFieldEnum.COMMISSION_OWNER,
  [PolicyColEnum.COMMISSION_AGENT]: PolicyManagementSortFieldEnum.COMMISSION_AGENT,
  [PolicyColEnum.COMMISSION_TEAM]: PolicyManagementSortFieldEnum.COMMISSION_TEAM,
  [PolicyColEnum.COMMISSION_PERCENTAGE]: PolicyManagementSortFieldEnum.COMMISSION_PERCENTAGE,
  [PolicyColEnum.CREATED_BY]: PolicyManagementSortFieldEnum.CREATED_BY
};

export const PolicyColLabel: { [key: string]: string } = {
  [PolicyColEnum.NUMBER]: 'policy-no',
  [PolicyColEnum.LEAD]: 'lead',
  [PolicyColEnum.CREATED_AT]: 'created-date',
  [PolicyColEnum.OWNER]: 'owner',
  [PolicyColEnum.AGENT]: 'agent',
  [PolicyColEnum.STATUS]: 'policy-status',
  [PolicyColEnum.TRACKING]: 'policy-tracking',
  [PolicyColEnum.EFFECTIVE_DATE]: 'effective-date',
  [PolicyColEnum.MODE]: 'premium-mode',
  [PolicyColEnum.PAYMENT]: 'premium-payment',
  [PolicyColEnum.TARGET]: 'target-premium',
  [PolicyColEnum.FACE_AMOUNT]: 'face-amount',
  [PolicyColEnum.COMPANY]: 'company',
  [PolicyColEnum.PRODUCT_TYPE]: 'product-type',
  [PolicyColEnum.PRODUCT_NAME]: 'product-name',
  [PolicyColEnum.CONTRIBUTION_YEARS]: 'contribution-years',
  [PolicyColEnum.COMMISSION_OWNER]: 'commission-owner',
  [PolicyColEnum.COMMISSION_AGENT]: 'commission-agent',
  [PolicyColEnum.COMMISSION_TEAM]: 'commission-team',
  [PolicyColEnum.COMMISSION_PERCENTAGE]: 'commission-percentage',
  [PolicyColEnum.CREATED_BY]: 'created-by',
  [PolicyColEnum.DESCRIPTION]: 'description'
};

